<template>
  <div>
    <canvas :id="data.key" :ref="data.key" width="500px" height="300px"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const chartElement = this.$refs[this.data.key];
      const ctx = chartElement.getContext('2d');

      const myChart = new Chart(ctx, {
        type: 'doughnut', // Use 'doughnut' for a donut chart
        data: {
          labels: [this.data.data[0].name, this.data.data[1].name],
          datasets: [
            {
              data: [
                parseFloat(this.data.data[0].value).toFixed(2),
                parseFloat(this.data.data[1].value).toFixed(2)
              ],
              backgroundColor: ['#2E8B57', '#CD5C5C'],
              hoverBackgroundColor: ['#2E8B57', '#CD5C5C'],
              borderWidth: 0,
              font: {
                weight: 'bold'
              },
            }
          ]
        },
        options: {
          animation: false, // Disable animation
          title: {
            display: true,
            text: this.data.name,
            fontSize: 18,
            fontStyle: 'bold',
            position: 'top',
            padding: 10
          },
          legend: {
            display: true,
            position: 'bottom'
          },
          plugins: {
            datalabels: {
              color: '#fff',
              borderRadius: 4,
              font: {
                weight: 'bold',
                size: 15
              },
              clamp: true,
            }
          }
        }
      });
    }
  }
};
</script>

<style></style>
